import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import LoginModal from '../LoginModal'
import RegisterModal from '../RegisterModal'
import ForgotModal from '../ForgotModal'
import { clearSession, logout, refreshUser } from '../../actions/userActions'
import { CHANGE_FORGOT_PASSWORD_RESET, GOOGLE_RESET } from '../../constants/userConstants'
import { hasRefreshToken, hasUsableSession } from '../../utils/authSession'

function useLandingAuth() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loginModal, setLoginModal] = useState(false)
  const [registerModal, setRegisterModal] = useState(false)
  const [forgotModal, setForgotModal] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { loading: loadingUser, userInfo } = userLogin

  const googleInfo = useSelector(state => state.googleLogin)
  const { success } = googleInfo

  useEffect(() => {
    if (success) {
      dispatch({ type: GOOGLE_RESET })
      navigate('/home')
    }
  }, [success, dispatch, navigate])

  useEffect(() => {
    let cancelled = false

    const validateStoredSession = async () => {
      if (!userInfo) return
      if (!hasRefreshToken(userInfo)) {
        dispatch(clearSession())
        return
      }
      if (hasUsableSession(userInfo, 30)) return

      try {
        const { data } = await axios.post('/api/user/token/refresh/', {
          refresh: userInfo.refresh,
        })
        if (!cancelled) dispatch(refreshUser({ ...userInfo, ...data }))
      } catch (error) {
        if (!cancelled) dispatch(clearSession())
      }
    }

    validateStoredSession()

    return () => {
      cancelled = true
    }
  }, [dispatch, userInfo])

  const openModal = (type) => {
    if (type === 'login') setLoginModal(true)
    if (type === 'register') setRegisterModal(true)
    if (type === 'forgot') setForgotModal(true)
  }

  const logoutHandler = () => {
    if (userInfo?.refresh) {
      dispatch(logout(userInfo.refresh))
    } else {
      dispatch(clearSession())
    }
  }

  const authModals = (
    <>
      {loginModal && (
        <LoginModal
          closeCallback={() => { setLoginModal(false) }}
          registerCallback={() => { setLoginModal(false); setRegisterModal(true) }}
          forgotCallback={() => {
            dispatch({ type: CHANGE_FORGOT_PASSWORD_RESET })
            setLoginModal(false)
            setForgotModal(true)
          }}
        />
      )}

      {registerModal && (
        <RegisterModal closeCallback={() => { setRegisterModal(false) }} loginCallback={() => { setRegisterModal(false); setLoginModal(true) }} />
      )}

      {forgotModal && (
        <ForgotModal closeCallback={() => { setForgotModal(false) }} />
      )}
    </>
  )

  return {
    loadingUser,
    userInfo: hasUsableSession(userInfo, 0) || hasRefreshToken(userInfo) ? userInfo : null,
    openModal,
    logoutHandler,
    authModals,
  }
}

export default useLandingAuth
